import { render, staticRenderFns } from "./rankingMetaAtual.vue?vue&type=template&id=bb9cc82c&scoped=true"
import script from "./rankingMetaAtual.vue?vue&type=script&lang=js"
export * from "./rankingMetaAtual.vue?vue&type=script&lang=js"
import style0 from "./rankingMetaAtual.vue?vue&type=style&index=0&id=bb9cc82c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9cc82c",
  null
  
)

export default component.exports